import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useNavigate, useLocation } from "react-router-dom";
import { getTabIcon } from "../sections/utils/tab-icons";

export interface TabConfig {
    id: string;
    name: string;
    icon?: string;
    type?: string;
}

export interface TabsContainerProps {
    tabs: TabConfig[];
    children: React.ReactNode[];
    initialTab?: number;
    onTabChange?: (index: number) => void;
    sx?: any;
}

export function TabsContainer(props: TabsContainerProps) {
    const { tabs, children, initialTab = 0, onTabChange, sx } = props;
    const navigate = useNavigate();
    const location = useLocation();
    const [activeTab, setActiveTab] = React.useState(initialTab);

    React.useEffect(() => {
        // On mount, check for tab query param and set activeTab accordingly
        const params = new URLSearchParams(location.search);
        const tabId = params.get("tab");
        if (tabId) {
            const idx = tabs.findIndex((tab) => tab.id === tabId);
            if (idx !== -1 && idx !== activeTab) {
                setActiveTab(idx);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search, tabs]);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
        if (onTabChange) onTabChange(newValue);
        // Update the URL with the current tab id
        const params = new URLSearchParams(location.search);
        params.set("tab", tabs[newValue].id);
        navigate({ pathname: location.pathname, search: params.toString() }, { replace: true });
    };

    return (
        <Box sx={sx}>
            <Tabs
                value={activeTab}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
            >
                {tabs.map((tab, idx) => (
                    <Tab
                        key={tab.id}
                        label={
                            <span
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "8px"
                                }}
                            >
                                <span /> {getTabIcon(tab as any)} {tab.name}
                            </span>
                        }
                        id={`tablink-${tab.id}`}
                        sx={{ minWidth: 120 }}
                    />
                ))}
            </Tabs>
            <Box sx={{ p: 2 }}>{children[activeTab]}</Box>
        </Box>
    );
}
